import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';

import { colorsV2 } from '../../colors-v2';
import { ResponsiveTypography } from '../../Typography/v3/ResponsiveTypography';
import { ElementTableOfContentHeadingBullet } from '../ElementTableOfContentHeadingBullet/ElementTableOfContentHeadingBullet';

const Headline = styled.div`
  display: flex;
  align-items: center;

  padding: 6px 0;
  cursor: pointer;
`;

const Container = styled.div`
  position: relative;

  display: flex;
  align-items: center;

  .item-headline {
    flex: 1;
  }

  .item-text {
    color: ${colorsV2.neutral120};
  }

  &:hover {
    .item-text {
      color: ${colorsV2.primary100};
    }
  }

  &.active {
    .item-text {
      color: ${colorsV2.primary100};
    }
  }

  &.h3 {
    padding-left: 24px;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 4px;
      height: 100%;
      border-left: 1px solid ${colorsV2.neutral20};
    }

    &.active {
      &:before {
        border-left: 1px solid ${colorsV2.primary100};
      }
    }
  }

  &.h4 {
    padding-left: 48px;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 4px;
      height: 100%;
      border-left: 1px solid ${colorsV2.neutral20};
    }

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 28px;
      height: 100%;
      border-left: 1px solid ${colorsV2.neutral20};
    }

    &.active {
      &:after {
        border-left: 1px solid ${colorsV2.primary100};
      }
    }
  }
`;

interface BlogItemTableOfContentProps {
  type?: 'h2' | 'h3' | 'h4';
  order?: number // start from 1
  text?: string;

  onClick?: () => void;

  withOrder?: boolean;
  active?: boolean;
}

export const ElementTableOfContentHeading = (props: BlogItemTableOfContentProps) => {
  const { type = 'h2', text, order, onClick, withOrder = false, active = false } = props;

  let bulletType = 'roman-numeral';

  switch (type) {
    case 'h4':
      bulletType = 'latin-number';
      break;
    case 'h3':
      bulletType = 'icon';
      break;
  }

  return (
    <Container className={cl('blog-item-table-of-content', type, { active })} onClick={onClick}>
      <Headline className="item-headline">
        {withOrder && Number.isFinite(order) && (
          <ElementTableOfContentHeadingBullet
            type={bulletType as any}
            order={order}
            active={active}
          />
        )}
        <ResponsiveTypography.Paragraph className="item-text" variant="medium/14-20">
          {text}
        </ResponsiveTypography.Paragraph>
      </Headline>
    </Container>
  );
};
